import { Button, message } from "antd";
import { Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import usePostData from "../../../api/usePostData";
import Recaptcha from "../../Recaptcha/Recaptcha";
import { loginValidationSchema } from "../../../utils/validations";
import { LoginTracking } from "../../../utils/mixpanel";
import { saveUserData } from "../../../redux/slices/authSlice";
import AppInput from "../../../common/AppInput";
import PropTypes from "prop-types"; 

export default function AccountLoginStep({setExistEmail, email}) {
     const navigate = useNavigate();
      const dispatch = useDispatch();
      const [recaptchaToken, setRecaptchaToken] = useState(null);
      const recaptchaRef = useRef(null);
    
      const {
        postData: checkEmail,
        errors: checkingEmailErrors,
        loading: checkingEmail,
      } = usePostData();
      const {
        postData: login,
        errors: loginError,
        loading: loggingIn,
      } = usePostData();
    
      const {
        t,
        i18n: { language },
      } = useTranslation("global");
    
      const validationSchema = loginValidationSchema;
    
      const initialValues = { email: email || "", password: "" };
      const onSubmit = async (values, { setSubmitting }) => {
        if (recaptchaToken == null) {
          return message.error(t("recaptchaRequired"));
        }
        const { email, password } = values;
        const checkUserType = await checkEmail({ route: `api/method/airport_transport.api.user.detect_email?email=${email}`, disableLogout: true });
        if (checkUserType.status === 200) {
          const route =
            checkUserType.data.msg === "Transport User"
              ? "api/method/airport_transport.api.user.login"
              : "api/method/airport_transport.api.agent.login";
          const res = await login({ route, data: { usr: email, pwd: password }, params: { headers: { recaptchaToken, }, },  disableLogout: true});
          if (res.status === 200) {
            LoginTracking(true);
            const { token, ...userData } = res.data.data;
            dispatch(saveUserData({ token, userData }));
          }
        }
        setSubmitting(false);
        recaptchaRef?.current.reset();
        setRecaptchaToken(null);
      };
    
      useEffect(() => {
        if (checkingEmailErrors) {
          const errorMsg =
            language === "ar" ? "لا يوجد مستخدم" : `${checkingEmailErrors?.error}`;
          message.error(errorMsg);
          LoginTracking(false, checkingEmailErrors?.error);
        }
      }, [checkingEmailErrors]);
    
      useEffect(() => {
        if (loginError && !loggingIn) {
          message.error(t("errors.invalid_username_or_password"));
          LoginTracking(false, loginError);
        }
      }, [loginError, loggingIn]);

  return (
    <Formik
    initialValues={initialValues}
    validationSchema={validationSchema}
    onSubmit={onSubmit}
  >
    {({ values, errors, touched }) => (
      <Form>
        <h5 className="text-center text-2xl font-medium mt-3">
          {t("hero.sign_in_text")}
        </h5>
        <AppInput
          name="email"
          type="email"
          label={t("hero.enter_email_text")}
          error={errors.email}
          touched={touched.email}
        />

        <AppInput
          name="password"
          type="password"
          label={t("hero.password_text")}
          error={errors.password}
          touched={touched.password}
        />

        {/* Integrate Recaptcha component */}
        <div>
          <Recaptcha
            recaptchaRef={recaptchaRef}
            onChange={(value) => {
              setRecaptchaToken(value);
            }}
          />
        </div>

        <button
          className="mt-0 md:mt-2 lg:mt-0 w-full text-sm flex justify-end rtl:justify-start text-text_steel_blue cursor-pointer"
          onClick={() => navigate("/forget-password")}
          dir={language === "ar" ? "rtl" : "ltr"}
          type="button"
        >
          {t("hero.forget_password_text")}
        </button>

        <div className="text-center mt-3 md:mt-6 lg:mt-2">
          <Button
            className="bg-background_steel_blue w-full text-text_white hover:bg-gray-100 font-medium rounded text-sm px-5 py-2.5 mb-2"
            type="submit"
            loading={checkingEmail || loggingIn}
            htmlType="submit"
          >
            {t("header.sign_in_text")}
          </Button>
        </div>

        <div className="mt-2 w-full text-sm flex flex-col md:flex-row items-center justify-center text-text_lightdark_grey cursor-pointer">
          <span>{t("no_account_text")}</span>
          <button
            className="text-sm font-semibold mr-2 text-text_steel_blue hover:underline ml-2"
            onClick={() => setExistEmail(false)}
          >
            {t("header.create_text")}
          </button>
        </div>
      </Form>
    )}
  </Formik>
  )

}
AccountLoginStep.propTypes = {
    setExistEmail: PropTypes.func,
    email: PropTypes.string,
  };
